
import { styled, TooltipProps } from "@mui/material";
import { Tooltip } from "@mui/material";

const ErrorTooltip = styled(({ className, onTouchMoveCapture, ...props }: TooltipProps) => (
    <Tooltip placement="top" arrow disableFocusListener disableHoverListener disableTouchListener {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: theme.palette.error.main,
        color: "#ffffff"
    },
    [`& .MuiTooltip-arrow`]: {
        color: theme.palette.error.main
    },
}));

export default ErrorTooltip;